<template>
  <div class="flex items-center gap-3 rounded-lg border p-2">
    <img
      v-if="product?.image"
      :src="product.image"
      :alt="product.name"
      class="w-16 h-16 rounded-lg object-contain bg-white"
    >
    <div v-else class="w-16 h-16 rounded-lg bg-slate-200" />
    <div class="min-w-0">
      <div class="text-sm font-medium">
        {{ advice.title }}
      </div>
      <div v-if="product" class="text-slate-500 text-xs">
        {{ product.code }}
      </div>
      <div v-if="advice.description" class="text-sm text-slate-600">
        {{ advice.description }}
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import {computed} from "vue";
import {SupportProgramStaticAdvice} from "@/program/interfaces/Program";

const props = defineProps<{
    advice: SupportProgramStaticAdvice;
}>();

const product = computed(() => props.advice.products[0]);
</script>
